import React from 'react';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

type AboutData = { story?: string; summary?: string };

function About() {
  const about = setup.about as AboutData;
  const story = about.story || about.summary;

  return (
    <MotionSection id="about">
      <SectionHeader
        eyebrow="Profile"
        title="About"
        subtitle="How I got here—and what I build today."
      />
      <div className="max-w-3xl">
        <p className="text-base sm:text-lg text-ink-secondary leading-[1.75]">
          {story}
        </p>
      </div>
    </MotionSection>
  );
}

export default About;
